import { formatRefillInterval, type RefillInterval } from '@snootsvet/shared'

import { Button } from '@/frontend/components/ui/button'
import { Input } from '@/frontend/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/frontend/components/ui/select'

const presets: RefillInterval[] = [
  { amount: 30, unit: 'days' },
  { amount: 1, unit: 'months' },
  { amount: 3, unit: 'months' },
]

export function RefillIntervalPicker({
  id,
  value,
  onChange,
  onBlur,
  disabled,
  invalid,
}: {
  id: string
  value: RefillInterval
  onChange: (value: RefillInterval) => void
  onBlur: () => void
  disabled?: boolean
  invalid?: boolean
}) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <div className="flex min-w-40 flex-1 items-center">
        <Input
          id={id}
          type="number"
          step={1}
          aria-invalid={invalid}
          value={value.amount || ''}
          onChange={(event) => onChange({ ...value, amount: Number(event.target.value) })}
          onBlur={onBlur}
          disabled={disabled}
          className="min-w-0 rounded-r-none"
        />
        <Select
          value={value.unit}
          onValueChange={(unit) => {
            if (unit === 'days' || unit === 'months') onChange({ ...value, unit })
          }}
          disabled={disabled}
          items={[
            { value: 'days', label: 'Days' },
            { value: 'months', label: 'Months' },
          ]}
        >
          <SelectTrigger
            aria-label="Refill interval unit"
            className="w-28 rounded-l-noneborder-l-0"
            onBlur={onBlur}
          >
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="days">Days</SelectItem>
            <SelectItem value="months">Months</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {presets.map((preset) => (
        <Button
          key={`${preset.amount}-${preset.unit}`}
          type="button"
          variant="outline"
          disabled={disabled}
          className="rounded-full text-muted-foreground"
          onClick={() => onChange(preset)}
        >
          {formatRefillInterval(preset)}
        </Button>
      ))}
    </div>
  )
}
